import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { wishlistMutations } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { LOCAL_STORAGE_WISH_LIST_KEY } from '../constants/StorageKeysConstants';
import { wishListActions } from '../redux/wishList/actions/WishListActions.creators';
import LocalStorageUtil from '../util/LocalStorageUtil';
export const useWishlist = () => {
    const { defaultRequestParams, servicesEndpoint, authenticationConfig } = useAemConfig();
    const { wishlistLoginMutation, wishlistLogoutMutation } = wishlistMutations({
        servicesEndpoint,
        defaultRequestParams,
    });
    const dispatch = useDispatch();
    const { mutateAsync: wishlistLogin } = useMutation(wishlistLoginMutation());
    const { mutateAsync: wishlistLogout } = useMutation(wishlistLogoutMutation());
    const login = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield wishlistLogin(authenticationConfig);
            dispatch(wishListActions.getWishListProducts());
            LocalStorageUtil.removeItem(LOCAL_STORAGE_WISH_LIST_KEY);
        }
        catch (_a) { }
    });
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield wishlistLogout(authenticationConfig);
            LocalStorageUtil.removeItem(LOCAL_STORAGE_WISH_LIST_KEY);
        }
        catch (_a) { }
    });
    return { wishlistLogin: login, wishlistLogout: logout };
};
